import Vue from 'vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

// Fal
import {
	faCamera as falCamera,
	faPencilRuler as falPencilRuler,
	faInfoCircle as falInfoCircle,
	faSync as falSync,
	faShareSquare as falShareSquare,
	faFileSpreadsheet as falFileSpreadsheet,
	faTags as falTags,
	faPrint as falPrint,
	faDollyFlatbedAlt as falDollyFlatbedAlt,
	faChartPie as falChartPie,
	faReceipt as falReceipt,
	faBoxes as falBoxes,
	faFileSignature as falFileSignature,
	faUpload as falUpload,
	faChartLine as falChartLine,
	faTruckLoading as falTruckLoading,
	faFilePdf as falFilePdf,
	faFileInvoiceDollar as falFileInvoiceDollar,
	faHistory as falHistory,
	faShippingFast as falShippingFast,
	faStream as falStream,
	faUnlock as falUnlock,
	faQuestionCircle as falQuestionCircle,
	faCogs as falCogs,
	faBars,
	faTimes as falTimes,
	faHome as falHome,
	faUserAlt as falUserAlt,
	faBuilding as falBuilding,
	faWarehouse as falWarehouse,
	faWarehouseAlt as falWarehouseAlt,
	faCarSide as falCarSide,
	faWrench as falWrench,
	faUserEdit,
	faUserCog,
	faHammer as falHammer,
	faLink as falLink,
	faCog as falCog,
	faChartBar as falChartBar,
	faMoneyBillAlt as falMoneyBillAlt,
	faUsers as falUsers,
	faFilter,
	faCalendar,
	faCalendarAlt,
	faCalendarDay,
	faPlus,
	faSlidersV,
	faFolderOpen,
	faFolderTree as falFolderTree,
	faFileCheck as falFileCheck,
	faPencil,
	faClipboardUser as falClipboardUser,
	faShoppingCart as falShoppingCart,
	faPrint,
	faForklift as falForklift,
	faBarcodeAlt,
	faFilePlus,
	faSparkles as falSparkles,
	faTasks as falTasks,
	faWindowRestore,
	faEllipsisV,
	faThLarge,
	faWindow as falWindow,
	faThList,
	faAngleDown as falAngleDown,
	faBell as falBell,
	faPlusCircle as falPlusCircle,
	faTrash as falTrash,
	faTrashAlt as falTrashAlt,
	faChevronRight as falChevronRight,
	faChevronLeft as falChevronLeft,
	faKey as falKey,
	faBoxOpen as falBoxOpen,
	faLayerGroup as falLayerGroup,
	faCircle as falCircle,
	faFileAlt as falFielAlt,
	faFileExcel as falFileExcel,
	faEdit as falEdit,
	faRegistered as falRegistered,
	faTag as falTag,
	faBarcode as falBarcode,
	faMapMarkerAlt as falMapMarkerAlt,
	faTruck as falTruck,
	faComment as falComment,
	faImage as falImage,
	faHandHoldingBox as falHandHoldingBox,
	faArrowLeft as falArrowLeft,
	faArrowUp as falArrowUp,
	faDownload as falDownload,
	faEye as falEye,
	faExclamationTriangle as falExclamationTriangle,
	faUmbrellaBeach as falUmbrellaBeach
} from '@fortawesome/pro-light-svg-icons'

// Fas
import {
	faSparkles as fasSparkles,
	faPlus as fasPlus,
	faCubes as fasCubes,
	faShareSquare as fasShareSquare,
	faFileSpreadsheet as fasFileSpreadsheet,
	faTags as fasTags,
	faLockAlt as fasLockAlt,
	faLockOpenAlt as fasLockOpenAlt,
	faDollyFlatbedAlt as fasDollyFlatbedAlt,
	faFileSignature as fasFileSignature,
	faTruckLoading as fasTruckLoading,
	faBold as fasBold,
	faQuoteRight as fasQuoteRight,
	faFileInvoiceDollar as fasFileInvoiceDollar,
	faTasks as fasTasks,
	faHome as fasHome,
	faTimes as fasTimes,
	faUserAlt as fasUserAlt,
	faBuilding as fasBuilding,
	faWarehouse as fasWarehouse,
	faHammer as fasHammer,
	faWarehouseAlt as fasWarehouseAlt,
	faUsers as fasUsers,
	faCommentAlt as fasComment,
	faCarSide as fasCarSide,
	faWrench as fasWrench,
	faTimesCircle as fasTimesCircle,
	faShare,
	faTruck as fasTruck,
	faBug as fasBug,
	faClipboardUser as fasClipboardUser,
	faSortDown,
	faRegistered as fasRegistered,
	faMotorcycle as fasMotorcycle,
	faCaretDown,
	faCamera,
	faReply,
	faMobileAlt as fasMobileAlt,
	faCog as fasCog,
	faForklift as fasForklift,
	faChartBar as fasChartBar,
	faFileCheck as fasFileCheck,
	faLongArrowUp as fasLongArrowUp,
	faLongArrowDown as fasLongArrowDown,
	faShoppingCart as fasShoppingCart,
	faMinus as fasMinus,
	faArrowRight,
	faTrash as fasTrash,
	faCheck as fasCheck,
	faCheckCircle as fasCheckCircle,
	faPen as fasPen,
	faSortNumericUp as fasSortNumericUp,
	faBan as fasBan,
	faStar as fasStar,
	faBoxOpen as fasBoxOpen,
	faFileAlt as fasFileAlt
} from '@fortawesome/pro-solid-svg-icons'

// Far
import {
	faAlignLeft as farAlignLeft,
	faAlignCenter as farAlignCenter,
	faAlignRight as farAlignRight,
	faSync as farSync,
	faParkingCircle as farParkingCircle,
	// faUpload as farUpload,
	faMotorcycle as farMotorcycle,
	faFilePdf as farFilePdf,
	faParagraph as farParagraph,
	faListUl as farListUl,
	faTruck as farTruck,
	faListOl as farListOl,
	faCode as farCode,
	faItalic as farItalic,
	faText as farText,
	faUnderline as farUnderline,
	faStrikethrough as farStrikethrough,
	faFileAlt as  farFileAlt,
	faQrcode as farQrCode,
	faScanner as farScanner,
	faSignOut as farSignOut,
	faCarSide as farCarSide,
	faTimes as farTimes,
	faTimesCircle as farTimesCircle,
	faListAlt as farListAlt,
	faSearch as farSearch,
	faExclamationCircle,
	faExclamationTriangle as farExclamationTriangle,
	faPrint as farPrint,
	faArrowDown,
	faLongArrowUp as farLongArrowUp,
	faLongArrowDown as farLongArrowDown,
	faArrowUp,
	faGripLines,
	faClock,
	faFrown as farFrown,
	faExchange,
	faWindow as farWindow,
	faAngleLeft,
	faAngleRight,
	faCubes as farCubes,
	faCheck as farCheck,
	faCheckCircle as farCheckCircle,
	faSadCry as farSadCry,
	faCircleNotch as farCircleNotch,
	faUndo as farUndo,
	faRedo as farRedo,
	faSearchPlus as farSearchPlus,
	faSearchMinus as farSearchMinus,
	faEdit as farEdit,
	faChevronRight as farChevronRight,
	faChevronLeft as farChevronLeft,
	faSave as farSave,
	faArrowFromLeft as farArrowFromLeft,
	faCrop as farCrop,
	faAdjust as farAdjust,
	faHighlighter as farHighlighter,
	faTrash as farTrash,
	faVectorSquare as farVectorSquare,
	faCircle as farCircle,
	faArrowAltRight as farArrowAltRight,
	faWaveSine as farWaveSine,
	faHorizontalRule as farHorizontalRule,
	faSquare as farSquare,
	faTriangle as farTriangle,
	faMousePointer as farMousePointer,
	faEye as farEye,
	faEyeSlash as farEyeSlash,
	faImages as farImages,
	faPlus as farPlus,
	faMinus as farMinus,
	faCopy as farCopy,
	faFile as farFile,
	faFileExcel as farFileExcel,
	faFileImage as farFileImage,
	faFileInvoice as farFileInvoice,
	faFileWord as farFileWord
} from '@fortawesome/pro-regular-svg-icons'

// // Fab
// import {
// 	faFirstDraft as fabFirstDraft
// } from '@fortawesome/bold-svg-icons'

library.add(
	falPencilRuler,
	falCamera,
	farAlignLeft,
	farAlignCenter,
	farAlignRight,
	farMotorcycle,
	fasMotorcycle,
	fasTags,
	falTags,
	fasSparkles,
	falSparkles,
	farSync,
	falSync,
	fasFileSignature,
	falFileSignature,
	farFileExcel,
	farFilePdf,
	farFile,
	fasSortNumericUp,
	fasBan,
	fasStar,
	farPlus,
	farMinus,
	farImages,
	farEye,
	farEyeSlash,
	farArrowAltRight,
	farCircle,
	falCircle,
	farSquare,
	farTriangle,
	farMousePointer,
	farEdit,
	farSearchMinus,
	farListAlt,
	faBars,
	falTimes,
	farTimes,
	fasTimes,
	farSearch,
	falHome,
	fasHome,
	falUserAlt,
	fasUserAlt,
	falBuilding,
	fasBuilding,
	falWarehouse,
	fasWarehouse,
	faCaretDown,
	faUserEdit,
	fasPlus,
	faSortDown,
	faUserCog,
	faPencil,
	fasPen,
	farWaveSine,
	farHorizontalRule,
	fasTimesCircle,
	farTimesCircle,
	faExclamationCircle,
	farExclamationTriangle,
	faEllipsisV,
	faArrowDown,
	farLongArrowDown,
	farLongArrowUp,
	faArrowUp,
	faArrowRight,
	falClipboardUser,
	fasClipboardUser,
	fasTrash,
	faWindowRestore,
	faClock,
	faPrint,
	faFilter,
	farText,
	faThLarge,
	faThList,
	falShoppingCart,
	fasShoppingCart,
	fasChartBar,
	falChartBar,
	falUsers,
	fasUsers,
	faAngleLeft,
	faAngleRight,
	falWarehouseAlt,
	fasWarehouseAlt,
	farCarSide,
	falCarSide,
	fasCarSide,
	fasBug,
	fasFileCheck,
	falFileCheck,
	faBarcodeAlt,
	fasRegistered,
	falRegistered,
	falWrench,
	fasWrench,
	fasComment,
	fasLongArrowUp,
	fasLongArrowDown,
	falAngleDown,
	farCheck,
	fasCheck,
	falBell,
	faPlus,
	faCamera,
	falPlusCircle,
	falTrash,
	falTrashAlt,
	falCog,
	fasCog,
	fasForklift,
	falForklift,
	falWindow,
	farWindow,
	faShare,
	faFolderOpen,
	falFolderTree,
	falChevronRight,
	falChevronLeft,
	faReply,
	farCircleNotch,
	farCheckCircle,
	faSlidersV,
	faFilePlus,
	fasTasks,
	falTasks,
	faCalendar,
	faCalendarAlt,
	faCalendarDay,
	fasMinus,
	farUndo,
	farRedo,
	falLink,
	falKey,
	fasMobileAlt,
	fasTruck,
	farTruck,
	farSearchPlus,
	faGripLines,
	faExchange,
	farFrown,
	farSadCry,
	farChevronRight,
	farChevronLeft,
	farSave,
	farArrowFromLeft,
	farCrop,
	farAdjust,
	farHighlighter,
	farTrash,
	farVectorSquare,
	fasHammer,
	falHammer,
	falChartLine,
	falMoneyBillAlt,
	fasCheckCircle,
	falCogs,
	falQuestionCircle,
	falUnlock,
	falStream,
	falShippingFast,
	farSignOut,
	farQrCode,
	falHistory,
	falBoxOpen,
	fasBoxOpen,
	falLayerGroup,
	fasBold,
	farItalic,
	falInfoCircle,
	farStrikethrough,
	farUnderline,
	farCode,
	farListOl,
	farListUl,
	fasQuoteRight,
	farParagraph,
	farFileImage,
	farFileInvoice,
	farFileWord,
	farCopy,
	fasFileAlt,
	falFielAlt,
	farFileAlt,
	falFileExcel,
	falEdit,
	falFileInvoiceDollar,
	fasFileInvoiceDollar,
	falFilePdf,
	falUpload,
	falTruckLoading,
	fasTruckLoading,
	farCubes,
	fasCubes,
	fasDollyFlatbedAlt,
	falDollyFlatbedAlt,
	farScanner,
	falPrint,
	farPrint,
	falFileSpreadsheet,
	fasFileSpreadsheet,
	fasShareSquare,
	farParkingCircle,
	falTag,
	falBarcode,
	falMapMarkerAlt,
	falTruck,
	falComment,
	falImage,
	falShareSquare,
	fasLockAlt,
	falReceipt,
	falBoxes,
	falChartPie,
	fasLockOpenAlt,
	falHandHoldingBox,
	falArrowLeft,
	falArrowUp,
	falDownload,
	falEye,
	falExclamationTriangle,
	falUmbrellaBeach
)

Vue.component('FontAwesomeIcon', FontAwesomeIcon)
